const MAX_TILES = 4

export const mutations = {
  SET_TILES (state, { orgId, tiles }) {
    state.tiles = { ...state.tiles, [orgId]: [...new Set(tiles)].slice(0, MAX_TILES) }
  },

  SET_ARRANGEMENT (state, { orgId, arrangement }) {
    state.arrangement = { ...state.arrangement, [orgId]: arrangement }
  },

  SET_DIVIDERS (state, { orgId, x, y }) {
    const prev = state.dividers[orgId] || { x: 0.5, y: 0.5 }
    const clamp = (v) => Math.max(0.1, Math.min(0.9, v))
    state.dividers = {
      ...state.dividers,
      [orgId]: { x: x != null ? clamp(x) : prev.x, y: y != null ? clamp(y) : prev.y }
    }
  },

  SET_SYNC (state, { mapId, enabled }) {
    state.syncEnabled = { ...state.syncEnabled, [mapId]: enabled }
  },

  SET_INITIALIZED (state, { orgId }) {
    state.initialized = { ...state.initialized, [orgId]: true }
  },

  SET_FOCUSED_TILE (state, { mapId }) {
    state.focusedTile = mapId
  },
}
